import { render } from "./RestoreStudentGroupClass.vue?vue&type=template&id=1e7c3102"
import script from "./RestoreStudentGroupClass.vue?vue&type=script&lang=js"
export * from "./RestoreStudentGroupClass.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__